// Generated by scripts/anim/look_masks.py — do not edit. The texture keys that have a <key>_mask.webp
// (character look, 2026-10-29); portraits are DOM images, keyed 'portrait/<name>'.
export const MASKED = new Set([
  'bike_cloth_ken_ken_akc_sunglasses',
  'bike_cloth_ken_ken_cargo',
  'bike_cloth_ken_ken_jacket_plaid',
  'bike_cloth_ken_ken_jeans_black',
  'bike_cloth_ken_ken_joggers',
  'bike_cloth_ken_ken_shoes_boots',
  'bike_cloth_ken_ken_shoes_japonki',
  'bike_cloth_ken_ken_shoes_runner',
  'bike_cloth_ken_ken_shoes_white',
  'bike_cloth_ken_ken_shorts_denim',
  'bike_cloth_ken_ken_tee_brown',
  'bike_cloth_ken_ken_tee_logo',
  'bike_cloth_natalka_akc_kapelusz',
  'bike_cloth_natalka_bluzka_red',
  'bike_cloth_natalka_buty_balet',
  'bike_cloth_natalka_buty_kozaki',
  'bike_cloth_natalka_buty_sandaly',
  'bike_cloth_natalka_buty_sport',
  'bike_cloth_natalka_nat_basket_shoes',
  'bike_cloth_natalka_nat_jersey_basket',
  'bike_cloth_natalka_nat_parachute',
  'bike_cloth_natalka_nat_slipons_check',
  'bike_cloth_natalka_nat_sweater_band',
  'bike_cloth_natalka_nat_wellies',
  'bike_cloth_natalka_spodniczka_black',
  'bike_cloth_natalka_spodniczka_flowers',
  'bike_cloth_natalka_spodniczka_pink',
  'bike_hair_ken_ken_buzz',
  'bike_hair_ken_ken_curls',
  'bike_hair_ken_ken_fringe',
  'bike_hair_ken_ken_fringe_hat',
  'bike_hair_ken_ken_short_crop',
  'bike_hair_ken_ken_short_crop_hat',
  'bike_hair_ken_ken_spiky',
  'bike_hair_ken_ken_spiky_hat',
  'bike_hair_natalka_nat_half_up',
  'bike_hair_natalka_nat_half_up_hat',
  'bike_hair_natalka_nat_long_sleek',
  'bike_hair_natalka_nat_long_sleek_hat',
  'bike_hair_natalka_nat_pigtails',
  'bike_hair_natalka_nat_ponytail',
  'bike_hair_natalka_nat_ponytail_hat',
  'bike_hair_natalka_nat_ringlets',
  'bike_hair_natalka_nat_ringlets_hat',
  'bike_hair_natalka_nat_rounded_bob',
  'bike_hair_natalka_nat_rounded_bob_hat',
  'bike_hair_natalka_nat_wavy_lob',
  'bike_hair_natalka_nat_wavy_lob_hat',
  'bike_rider_ken',
  'bike_rider_natalka',
  'driver_ken',
  'driver_ken_ken_buzz',
  'driver_ken_ken_fringe',
  'driver_ken_ken_short_crop',
  'driver_ken_ken_spiky',
  'driver_natalka',
  'driver_natalka_nat_half_up',
  'driver_natalka_nat_long_sleek',
  'driver_natalka_nat_ponytail',
  'driver_natalka_nat_ponytail_r',
  'driver_natalka_nat_ringlets',
  'driver_natalka_nat_rounded_bob',
  'driver_natalka_nat_rounded_bob_r',
  'driver_natalka_nat_wavy_lob',
  'ken_pose',
  'ken_pose_hair_ken_buzz',
  'ken_pose_hair_ken_curls',
  'ken_pose_hair_ken_fringe',
  'ken_pose_hair_ken_short_crop',
  'ken_pose_hair_ken_spiky',
  'ken_pose_hairback_ken_buzz',
  'ken_pose_hairback_ken_curls',
  'ken_pose_hairback_ken_fringe',
  'ken_pose_hairback_ken_short_crop',
  'ken_pose_hairback_ken_spiky',
  'ken_pose_ken_akc_beanie',
  'ken_pose_ken_akc_sunglasses',
  'ken_pose_ken_cargo',
  'ken_pose_ken_hoodie',
  'ken_pose_ken_jacket_plaid',
  'ken_pose_ken_jeans_black',
  'ken_pose_ken_joggers',
  'ken_pose_ken_shoes_boots',
  'ken_pose_ken_shoes_japonki',
  'ken_pose_ken_shoes_runner',
  'ken_pose_ken_shoes_white',
  'ken_pose_ken_shorts_denim',
  'ken_pose_ken_tee_brown',
  'ken_pose_ken_tee_logo',
  'ken_pose_neck',
  'ken_walk',
  'ken_walk_body',
  'ken_walk_ears_ken_buzz',
  'ken_walk_ears_ken_fringe',
  'ken_walk_ears_ken_short_crop',
  'ken_walk_ears_ken_spiky',
  'ken_walk_hair_ken_buzz',
  'ken_walk_hair_ken_curls',
  'ken_walk_hair_ken_fringe',
  'ken_walk_hair_ken_short_crop',
  'ken_walk_hair_ken_spiky',
  'ken_walk_hairback_ken_buzz',
  'ken_walk_hairback_ken_curls',
  'ken_walk_hairback_ken_fringe',
  'ken_walk_hairback_ken_short_crop',
  'ken_walk_hairback_ken_spiky',
  'ken_walk_ken_akc_beanie',
  'ken_walk_ken_akc_beanie__bare',
  'ken_walk_ken_akc_cap',
  'ken_walk_ken_akc_cap__bare',
  'ken_walk_ken_akc_headphones',
  'ken_walk_ken_akc_sunglasses',
  'ken_walk_ken_cargo',
  'ken_walk_ken_hoodie',
  'ken_walk_ken_jacket_plaid',
  'ken_walk_ken_jeans_black',
  'ken_walk_ken_joggers',
  'ken_walk_ken_shoes_japonki',
  'ken_walk_ken_shorts_denim',
  'ken_walk_ken_tee_brown',
  'ken_walk_ken_tee_logo',
  'ken_walk_neck',
  'natalka_pose',
  'natalka_pose_akc_kapelusz',
  'natalka_pose_bluzka_green',
  'natalka_pose_bluzka_stripes',
  'natalka_pose_buty_sandaly',
  'natalka_pose_buty_sport',
  'natalka_pose_hair_nat_half_up',
  'natalka_pose_hair_nat_half_up_hat',
  'natalka_pose_hair_nat_long_sleek',
  'natalka_pose_hair_nat_pigtails',
  'natalka_pose_hair_nat_ponytail',
  'natalka_pose_hair_nat_ponytail_hat',
  'natalka_pose_hair_nat_ringlets',
  'natalka_pose_hair_nat_ringlets_hat',
  'natalka_pose_hair_nat_rounded_bob',
  'natalka_pose_hair_nat_wavy_lob',
  'natalka_pose_hairback_nat_half_up',
  'natalka_pose_hairback_nat_half_up_hat',
  'natalka_pose_hairback_nat_long_sleek',
  'natalka_pose_hairback_nat_pigtails',
  'natalka_pose_hairback_nat_ponytail',
  'natalka_pose_hairback_nat_ponytail_hat',
  'natalka_pose_hairback_nat_ringlets',
  'natalka_pose_hairback_nat_ringlets_hat',
  'natalka_pose_hairback_nat_rounded_bob',
  'natalka_pose_hairback_nat_wavy_lob',
  'natalka_pose_nat_basket_shoes',
  'natalka_pose_nat_bucket_hat',
  'natalka_pose_nat_corduroy',
  'natalka_pose_nat_flares_lavender',
  'natalka_pose_nat_fleece_brown',
  'natalka_pose_nat_jeans_wide',
  'natalka_pose_nat_jersey_basket',
  'natalka_pose_nat_joggers_light',
  'natalka_pose_nat_parachute',
  'natalka_pose_nat_patchwork',
  'natalka_pose_nat_slipons_check',
  'natalka_pose_nat_tee_blue_word',
  'natalka_pose_nat_tee_wave',
  'natalka_pose_nat_vest_puffer',
  'natalka_pose_neck',
  'natalka_pose_spodniczka_pink',
  'natalka_walk',
  'natalka_walk_akc_kapelusz',
  'natalka_walk_akc_kokarda',
  'natalka_walk_akc_okulary',
  'natalka_walk_bluzka_blue',
  'natalka_walk_bluzka_green',
  'natalka_walk_bluzka_red',
  'natalka_walk_bluzka_stripes',
  'natalka_walk_body',
  'natalka_walk_buty_balet',
  'natalka_walk_buty_sandaly',
  'natalka_walk_buty_sport',
  'natalka_walk_ears',
  'natalka_walk_ears_nat_half_up',
  'natalka_walk_ears_nat_half_up_hat',
  'natalka_walk_ears_nat_long_sleek',
  'natalka_walk_ears_nat_long_sleek_hat',
  'natalka_walk_ears_nat_ponytail',
  'natalka_walk_ears_nat_ponytail_hat',
  'natalka_walk_ears_nat_ringlets',
  'natalka_walk_ears_nat_ringlets_hat',
  'natalka_walk_ears_nat_rounded_bob',
  'natalka_walk_ears_nat_rounded_bob_hat',
  'natalka_walk_ears_nat_wavy_lob',
  'natalka_walk_ears_nat_wavy_lob_hat',
  'natalka_walk_hair_nat_half_up',
  'natalka_walk_hair_nat_half_up_hat',
  'natalka_walk_hair_nat_long_sleek',
  'natalka_walk_hair_nat_long_sleek_hat',
  'natalka_walk_hair_nat_pigtails',
  'natalka_walk_hair_nat_ponytail',
  'natalka_walk_hair_nat_ponytail_hat',
  'natalka_walk_hair_nat_ringlets',
  'natalka_walk_hair_nat_ringlets_hat',
  'natalka_walk_hair_nat_rounded_bob',
  'natalka_walk_hair_nat_rounded_bob_hat',
  'natalka_walk_hair_nat_wavy_lob',
  'natalka_walk_hair_nat_wavy_lob_hat',
  'natalka_walk_hairback_nat_half_up',
  'natalka_walk_hairback_nat_half_up_hat',
  'natalka_walk_hairback_nat_long_sleek',
  'natalka_walk_hairback_nat_long_sleek_hat',
  'natalka_walk_hairback_nat_pigtails',
  'natalka_walk_hairback_nat_ponytail',
  'natalka_walk_hairback_nat_ponytail_hat',
  'natalka_walk_hairback_nat_ringlets',
  'natalka_walk_hairback_nat_ringlets_hat',
  'natalka_walk_hairback_nat_rounded_bob',
  'natalka_walk_hairback_nat_rounded_bob_hat',
  'natalka_walk_hairback_nat_wavy_lob',
  'natalka_walk_hairback_nat_wavy_lob_hat',
  'natalka_walk_nat_basket_shoes',
  'natalka_walk_nat_bucket_hat',
  'natalka_walk_nat_bucket_hat__bare',
  'natalka_walk_nat_corduroy',
  'natalka_walk_nat_flares_lavender',
  'natalka_walk_nat_fleece_brown',
  'natalka_walk_nat_headband',
  'natalka_walk_nat_headband__nat_ponytail',
  'natalka_walk_nat_headphones',
  'natalka_walk_nat_jacket_denim',
  'natalka_walk_nat_jeans_wide',
  'natalka_walk_nat_joggers_light',
  'natalka_walk_nat_parachute',
  'natalka_walk_nat_sweater_band',
  'natalka_walk_nat_sweater_knit',
  'natalka_walk_nat_tee_blue_word',
  'natalka_walk_nat_wellies',
  'natalka_walk_neck',
  'natalka_walk_spodniczka_black',
  'natalka_walk_spodniczka_flowers',
  'natalka_walk_spodniczka_jeans',
  'natalka_walk_spodniczka_pink',
  'portrait/ken_walk',
  'portrait/ken_walk_body',
  'portrait/ken_walk_ears_ken_buzz',
  'portrait/ken_walk_ears_ken_fringe',
  'portrait/ken_walk_ears_ken_short_crop',
  'portrait/ken_walk_ears_ken_spiky',
  'portrait/ken_walk_hair_ken_buzz',
  'portrait/ken_walk_hair_ken_curls',
  'portrait/ken_walk_hair_ken_fringe',
  'portrait/ken_walk_hair_ken_short_crop',
  'portrait/ken_walk_hair_ken_spiky',
  'portrait/ken_walk_hairback_ken_buzz',
  'portrait/ken_walk_hairback_ken_curls',
  'portrait/ken_walk_hairback_ken_fringe',
  'portrait/ken_walk_hairback_ken_short_crop',
  'portrait/ken_walk_hairback_ken_spiky',
  'portrait/ken_walk_ken_akc_cap',
  'portrait/ken_walk_ken_akc_cap__bare',
  'portrait/ken_walk_ken_akc_sunglasses',
  'portrait/ken_walk_ken_hoodie',
  'portrait/ken_walk_ken_tee_brown',
  'portrait/ken_walk_neck',
  'portrait/natalka_walk',
  'portrait/natalka_walk_akc_okulary',
  'portrait/natalka_walk_body',
  'portrait/natalka_walk_ears',
  'portrait/natalka_walk_ears_nat_half_up',
  'portrait/natalka_walk_ears_nat_half_up_hat',
  'portrait/natalka_walk_ears_nat_long_sleek',
  'portrait/natalka_walk_ears_nat_long_sleek_hat',
  'portrait/natalka_walk_ears_nat_ponytail',
  'portrait/natalka_walk_ears_nat_ponytail_hat',
  'portrait/natalka_walk_ears_nat_ringlets',
  'portrait/natalka_walk_ears_nat_ringlets_hat',
  'portrait/natalka_walk_ears_nat_rounded_bob',
  'portrait/natalka_walk_ears_nat_rounded_bob_hat',
  'portrait/natalka_walk_ears_nat_wavy_lob',
  'portrait/natalka_walk_ears_nat_wavy_lob_hat',
  'portrait/natalka_walk_hair_nat_half_up',
  'portrait/natalka_walk_hair_nat_half_up_hat',
  'portrait/natalka_walk_hair_nat_long_sleek',
  'portrait/natalka_walk_hair_nat_long_sleek_hat',
  'portrait/natalka_walk_hair_nat_pigtails',
  'portrait/natalka_walk_hair_nat_ponytail',
  'portrait/natalka_walk_hair_nat_ponytail_hat',
  'portrait/natalka_walk_hair_nat_ringlets',
  'portrait/natalka_walk_hair_nat_ringlets_hat',
  'portrait/natalka_walk_hair_nat_rounded_bob',
  'portrait/natalka_walk_hair_nat_rounded_bob_hat',
  'portrait/natalka_walk_hair_nat_wavy_lob',
  'portrait/natalka_walk_hair_nat_wavy_lob_hat',
  'portrait/natalka_walk_hairback_nat_half_up',
  'portrait/natalka_walk_hairback_nat_half_up_hat',
  'portrait/natalka_walk_hairback_nat_long_sleek',
  'portrait/natalka_walk_hairback_nat_long_sleek_hat',
  'portrait/natalka_walk_hairback_nat_pigtails',
  'portrait/natalka_walk_hairback_nat_ponytail',
  'portrait/natalka_walk_hairback_nat_ponytail_hat',
  'portrait/natalka_walk_hairback_nat_ringlets',
  'portrait/natalka_walk_hairback_nat_ringlets_hat',
  'portrait/natalka_walk_hairback_nat_rounded_bob',
  'portrait/natalka_walk_hairback_nat_rounded_bob_hat',
  'portrait/natalka_walk_hairback_nat_wavy_lob',
  'portrait/natalka_walk_hairback_nat_wavy_lob_hat',
  'portrait/natalka_walk_nat_bucket_hat',
  'portrait/natalka_walk_nat_bucket_hat__bare',
  'portrait/natalka_walk_nat_jacket_denim',
  'portrait/natalka_walk_neck',
  'portrait/natalka_walk_spodniczka_black',
  'portrait/natalka_walk_spodniczka_flowers',
  'portrait/natalka_walk_spodniczka_jeans',
]);

// Each mask's width x height: the same as its atlas (what both cost decoded, x4 bytes).
export const MASK_PIXELS = {
  'bike_cloth_ken_ken_akc_sunglasses': 2512,
  'bike_cloth_ken_ken_cargo': 259741,
  'bike_cloth_ken_ken_jacket_plaid': 25150,
  'bike_cloth_ken_ken_jeans_black': 276892,
  'bike_cloth_ken_ken_joggers': 232432,
  'bike_cloth_ken_ken_shoes_boots': 160854,
  'bike_cloth_ken_ken_shoes_japonki': 145992,
  'bike_cloth_ken_ken_shoes_runner': 145111,
  'bike_cloth_ken_ken_shoes_white': 136633,
  'bike_cloth_ken_ken_shorts_denim': 110833,
  'bike_cloth_ken_ken_tee_brown': 16422,
  'bike_cloth_ken_ken_tee_logo': 10656,
  'bike_cloth_natalka_akc_kapelusz': 17280,
  'bike_cloth_natalka_bluzka_red': 13611,
  'bike_cloth_natalka_buty_balet': 142290,
  'bike_cloth_natalka_buty_kozaki': 146916,
  'bike_cloth_natalka_buty_sandaly': 139370,
  'bike_cloth_natalka_buty_sport': 140100,
  'bike_cloth_natalka_nat_basket_shoes': 149152,
  'bike_cloth_natalka_nat_jersey_basket': 13960,
  'bike_cloth_natalka_nat_parachute': 256672,
  'bike_cloth_natalka_nat_slipons_check': 125268,
  'bike_cloth_natalka_nat_sweater_band': 18450,
  'bike_cloth_natalka_nat_wellies': 174300,
  'bike_cloth_natalka_spodniczka_black': 106896,
  'bike_cloth_natalka_spodniczka_flowers': 158070,
  'bike_cloth_natalka_spodniczka_pink': 121220,
  'bike_hair_ken_ken_buzz': 9504,
  'bike_hair_ken_ken_curls': 18252,
  'bike_hair_ken_ken_fringe': 12012,
  'bike_hair_ken_ken_fringe_hat': 11742,
  'bike_hair_ken_ken_short_crop': 11628,
  'bike_hair_ken_ken_short_crop_hat': 10952,
  'bike_hair_ken_ken_spiky': 12920,
  'bike_hair_ken_ken_spiky_hat': 12012,
  'bike_hair_natalka_nat_half_up': 32016,
  'bike_hair_natalka_nat_half_up_hat': 28160,
  'bike_hair_natalka_nat_long_sleek': 23085,
  'bike_hair_natalka_nat_long_sleek_hat': 22904,
  'bike_hair_natalka_nat_pigtails': 28892,
  'bike_hair_natalka_nat_ponytail': 23729,
  'bike_hair_natalka_nat_ponytail_hat': 29295,
  'bike_hair_natalka_nat_ringlets': 19110,
  'bike_hair_natalka_nat_ringlets_hat': 14432,
  'bike_hair_natalka_nat_rounded_bob': 25636,
  'bike_hair_natalka_nat_rounded_bob_hat': 11692,
  'bike_hair_natalka_nat_wavy_lob': 15664,
  'bike_hair_natalka_nat_wavy_lob_hat': 14742,
  'bike_rider_ken': 351621,
  'bike_rider_natalka': 344148,
  'driver_ken': 12800,
  'driver_ken_ken_buzz': 12800,
  'driver_ken_ken_fringe': 12800,
  'driver_ken_ken_short_crop': 12800,
  'driver_ken_ken_spiky': 12800,
  'driver_natalka': 8960,
  'driver_natalka_nat_half_up': 8960,
  'driver_natalka_nat_long_sleek': 8960,
  'driver_natalka_nat_ponytail': 8960,
  'driver_natalka_nat_ponytail_r': 8960,
  'driver_natalka_nat_ringlets': 8960,
  'driver_natalka_nat_rounded_bob': 8960,
  'driver_natalka_nat_rounded_bob_r': 8960,
  'driver_natalka_nat_wavy_lob': 8960,
  'ken_pose': 49248,
  'ken_pose_hair_ken_buzz': 13680,
  'ken_pose_hair_ken_curls': 19152,
  'ken_pose_hair_ken_fringe': 16416,
  'ken_pose_hair_ken_short_crop': 16416,
  'ken_pose_hair_ken_spiky': 16416,
  'ken_pose_hairback_ken_buzz': 1,
  'ken_pose_hairback_ken_curls': 1,
  'ken_pose_hairback_ken_fringe': 1,
  'ken_pose_hairback_ken_short_crop': 1,
  'ken_pose_hairback_ken_spiky': 1,
  'ken_pose_ken_akc_beanie': 16416,
  'ken_pose_ken_akc_sunglasses': 10944,
  'ken_pose_ken_cargo': 19152,
  'ken_pose_ken_hoodie': 19152,
  'ken_pose_ken_jacket_plaid': 24624,
  'ken_pose_ken_jeans_black': 21888,
  'ken_pose_ken_joggers': 16416,
  'ken_pose_ken_shoes_boots': 13680,
  'ken_pose_ken_shoes_japonki': 10944,
  'ken_pose_ken_shoes_runner': 10944,
  'ken_pose_ken_shoes_white': 10944,
  'ken_pose_ken_shorts_denim': 27360,
  'ken_pose_ken_tee_brown': 16416,
  'ken_pose_ken_tee_logo': 13680,
  'ken_pose_neck': 10944,
  'ken_walk': 590976,
  'ken_walk_body': 539728,
  'ken_walk_ears_ken_buzz': 23968,
  'ken_walk_ears_ken_fringe': 21888,
  'ken_walk_ears_ken_short_crop': 21888,
  'ken_walk_ears_ken_spiky': 21888,
  'ken_walk_hair_ken_buzz': 140384,
  'ken_walk_hair_ken_curls': 195168,
  'ken_walk_hair_ken_fringe': 158688,
  'ken_walk_hair_ken_short_crop': 157872,
  'ken_walk_hair_ken_spiky': 157872,
  'ken_walk_hairback_ken_buzz': 1,
  'ken_walk_hairback_ken_curls': 16416,
  'ken_walk_hairback_ken_fringe': 1,
  'ken_walk_hairback_ken_short_crop': 2736,
  'ken_walk_hairback_ken_spiky': 1,
  'ken_walk_ken_akc_beanie': 148304,
  'ken_walk_ken_akc_beanie__bare': 148304,
  'ken_walk_ken_akc_cap': 126688,
  'ken_walk_ken_akc_cap__bare': 126688,
  'ken_walk_ken_akc_headphones': 51984,
  'ken_walk_ken_akc_sunglasses': 43776,
  'ken_walk_ken_cargo': 157872,
  'ken_walk_ken_hoodie': 216144,
  'ken_walk_ken_jacket_plaid': 199728,
  'ken_walk_ken_jeans_black': 199728,
  'ken_walk_ken_joggers': 138736,
  'ken_walk_ken_shoes_japonki': 103968,
  'ken_walk_ken_shorts_denim': 73728,
  'ken_walk_ken_tee_brown': 124384,
  'ken_walk_ken_tee_logo': 119600,
  'ken_walk_neck': 66976,
  'natalka_pose': 46512,
  'natalka_pose_akc_kapelusz': 21888,
  'natalka_pose_bluzka_green': 16416,
  'natalka_pose_bluzka_stripes': 16416,
  'natalka_pose_buty_sandaly': 10944,
  'natalka_pose_buty_sport': 10944,
  'natalka_pose_hair_nat_half_up': 27360,
  'natalka_pose_hair_nat_half_up_hat': 27360,
  'natalka_pose_hair_nat_long_sleek': 27360,
  'natalka_pose_hair_nat_pigtails': 19152,
  'natalka_pose_hair_nat_ponytail': 24624,
  'natalka_pose_hair_nat_ponytail_hat': 24624,
  'natalka_pose_hair_nat_ringlets': 24624,
  'natalka_pose_hair_nat_ringlets_hat': 24624,
  'natalka_pose_hair_nat_rounded_bob': 21888,
  'natalka_pose_hair_nat_wavy_lob': 21888,
  'natalka_pose_hairback_nat_half_up': 21888,
  'natalka_pose_hairback_nat_half_up_hat': 19152,
  'natalka_pose_hairback_nat_long_sleek': 19152,
  'natalka_pose_hairback_nat_pigtails': 10944,
  'natalka_pose_hairback_nat_ponytail': 19152,
  'natalka_pose_hairback_nat_ponytail_hat': 21888,
  'natalka_pose_hairback_nat_ringlets': 21888,
  'natalka_pose_hairback_nat_ringlets_hat': 21888,
  'natalka_pose_hairback_nat_rounded_bob': 16416,
  'natalka_pose_hairback_nat_wavy_lob': 16416,
  'natalka_pose_nat_basket_shoes': 13680,
  'natalka_pose_nat_bucket_hat': 13680,
  'natalka_pose_nat_corduroy': 19152,
  'natalka_pose_nat_flares_lavender': 19152,
  'natalka_pose_nat_fleece_brown': 21888,
  'natalka_pose_nat_jeans_wide': 19152,
  'natalka_pose_nat_jersey_basket': 16416,
  'natalka_pose_nat_joggers_light': 16416,
  'natalka_pose_nat_parachute': 16416,
  'natalka_pose_nat_patchwork': 16416,
  'natalka_pose_nat_slipons_check': 10944,
  'natalka_pose_nat_tee_blue_word': 16416,
  'natalka_pose_nat_tee_wave': 13680,
  'natalka_pose_nat_vest_puffer': 16416,
  'natalka_pose_neck': 10944,
  'natalka_pose_spodniczka_pink': 13680,
  'natalka_walk': 580032,
  'natalka_walk_akc_kapelusz': 202016,
  'natalka_walk_akc_kokarda': 73872,
  'natalka_walk_akc_okulary': 71760,
  'natalka_walk_bluzka_blue': 136960,
  'natalka_walk_bluzka_green': 153088,
  'natalka_walk_bluzka_red': 134064,
  'natalka_walk_bluzka_stripes': 130112,
  'natalka_walk_body': 546560,
  'natalka_walk_buty_balet': 90288,
  'natalka_walk_buty_sandaly': 123264,
  'natalka_walk_buty_sport': 106496,
  'natalka_walk_ears': 23968,
  'natalka_walk_ears_nat_half_up': 38272,
  'natalka_walk_ears_nat_half_up_hat': 43056,
  'natalka_walk_ears_nat_long_sleek': 32832,
  'natalka_walk_ears_nat_long_sleek_hat': 43056,
  'natalka_walk_ears_nat_ponytail': 45056,
  'natalka_walk_ears_nat_ponytail_hat': 53248,
  'natalka_walk_ears_nat_ringlets': 32832,
  'natalka_walk_ears_nat_ringlets_hat': 35568,
  'natalka_walk_ears_nat_rounded_bob': 57456,
  'natalka_walk_ears_nat_rounded_bob_hat': 51360,
  'natalka_walk_ears_nat_wavy_lob': 27360,
  'natalka_walk_ears_nat_wavy_lob_hat': 41088,
  'natalka_walk_hair_nat_half_up': 224848,
  'natalka_walk_hair_nat_half_up_hat': 224352,
  'natalka_walk_hair_nat_long_sleek': 258336,
  'natalka_walk_hair_nat_long_sleek_hat': 258336,
  'natalka_walk_hair_nat_pigtails': 221616,
  'natalka_walk_hair_nat_ponytail': 311584,
  'natalka_walk_hair_nat_ponytail_hat': 321104,
  'natalka_walk_hair_nat_ringlets': 208864,
  'natalka_walk_hair_nat_ringlets_hat': 194256,
  'natalka_walk_hair_nat_rounded_bob': 258048,
  'natalka_walk_hair_nat_rounded_bob_hat': 265392,
  'natalka_walk_hair_nat_wavy_lob': 177840,
  'natalka_walk_hair_nat_wavy_lob_hat': 172368,
  'natalka_walk_hairback_nat_half_up': 82080,
  'natalka_walk_hairback_nat_half_up_hat': 93024,
  'natalka_walk_hairback_nat_long_sleek': 110032,
  'natalka_walk_hairback_nat_long_sleek_hat': 112176,
  'natalka_walk_hairback_nat_pigtails': 117648,
  'natalka_walk_hairback_nat_ponytail': 41088,
  'natalka_walk_hairback_nat_ponytail_hat': 98304,
  'natalka_walk_hairback_nat_ringlets': 61488,
  'natalka_walk_hairback_nat_ringlets_hat': 49248,
  'natalka_walk_hairback_nat_rounded_bob': 41040,
  'natalka_walk_hairback_nat_rounded_bob_hat': 37664,
  'natalka_walk_hairback_nat_wavy_lob': 35568,
  'natalka_walk_hairback_nat_wavy_lob_hat': 30816,
  'natalka_walk_nat_basket_shoes': 116416,
  'natalka_walk_nat_bucket_hat': 180576,
  'natalka_walk_nat_bucket_hat__bare': 180576,
  'natalka_walk_nat_corduroy': 186048,
  'natalka_walk_nat_flares_lavender': 202016,
  'natalka_walk_nat_fleece_brown': 180576,
  'natalka_walk_nat_headband': 93024,
  'natalka_walk_nat_headband__nat_ponytail': 134064,
  'natalka_walk_nat_headphones': 43776,
  'natalka_walk_nat_jacket_denim': 248768,
  'natalka_walk_nat_jeans_wide': 205440,
  'natalka_walk_nat_joggers_light': 195168,
  'natalka_walk_nat_parachute': 175104,
  'natalka_walk_nat_sweater_band': 154080,
  'natalka_walk_nat_sweater_knit': 175104,
  'natalka_walk_nat_tee_blue_word': 124384,
  'natalka_walk_nat_wellies': 131328,
  'natalka_walk_neck': 62928,
  'natalka_walk_spodniczka_black': 164352,
  'natalka_walk_spodniczka_flowers': 147744,
  'natalka_walk_spodniczka_jeans': 207936,
  'natalka_walk_spodniczka_pink': 134064,
  'portrait/ken_walk': 11100,
  'portrait/ken_walk_body': 11100,
  'portrait/ken_walk_ears_ken_buzz': 11100,
  'portrait/ken_walk_ears_ken_fringe': 11100,
  'portrait/ken_walk_ears_ken_short_crop': 11100,
  'portrait/ken_walk_ears_ken_spiky': 11100,
  'portrait/ken_walk_hair_ken_buzz': 11100,
  'portrait/ken_walk_hair_ken_curls': 11100,
  'portrait/ken_walk_hair_ken_fringe': 11100,
  'portrait/ken_walk_hair_ken_short_crop': 11100,
  'portrait/ken_walk_hair_ken_spiky': 11100,
  'portrait/ken_walk_hairback_ken_buzz': 11100,
  'portrait/ken_walk_hairback_ken_curls': 11100,
  'portrait/ken_walk_hairback_ken_fringe': 11100,
  'portrait/ken_walk_hairback_ken_short_crop': 11100,
  'portrait/ken_walk_hairback_ken_spiky': 11100,
  'portrait/ken_walk_ken_akc_cap': 11100,
  'portrait/ken_walk_ken_akc_cap__bare': 11100,
  'portrait/ken_walk_ken_akc_sunglasses': 11100,
  'portrait/ken_walk_ken_hoodie': 11100,
  'portrait/ken_walk_ken_tee_brown': 11100,
  'portrait/ken_walk_neck': 11100,
  'portrait/natalka_walk': 11100,
  'portrait/natalka_walk_akc_okulary': 11100,
  'portrait/natalka_walk_body': 11100,
  'portrait/natalka_walk_ears': 11100,
  'portrait/natalka_walk_ears_nat_half_up': 11100,
  'portrait/natalka_walk_ears_nat_half_up_hat': 11100,
  'portrait/natalka_walk_ears_nat_long_sleek': 11100,
  'portrait/natalka_walk_ears_nat_long_sleek_hat': 11100,
  'portrait/natalka_walk_ears_nat_ponytail': 11100,
  'portrait/natalka_walk_ears_nat_ponytail_hat': 11100,
  'portrait/natalka_walk_ears_nat_ringlets': 11100,
  'portrait/natalka_walk_ears_nat_ringlets_hat': 11100,
  'portrait/natalka_walk_ears_nat_rounded_bob': 11100,
  'portrait/natalka_walk_ears_nat_rounded_bob_hat': 11100,
  'portrait/natalka_walk_ears_nat_wavy_lob': 11100,
  'portrait/natalka_walk_ears_nat_wavy_lob_hat': 11100,
  'portrait/natalka_walk_hair_nat_half_up': 11100,
  'portrait/natalka_walk_hair_nat_half_up_hat': 11100,
  'portrait/natalka_walk_hair_nat_long_sleek': 11100,
  'portrait/natalka_walk_hair_nat_long_sleek_hat': 11100,
  'portrait/natalka_walk_hair_nat_pigtails': 11100,
  'portrait/natalka_walk_hair_nat_ponytail': 11100,
  'portrait/natalka_walk_hair_nat_ponytail_hat': 11100,
  'portrait/natalka_walk_hair_nat_ringlets': 11100,
  'portrait/natalka_walk_hair_nat_ringlets_hat': 11100,
  'portrait/natalka_walk_hair_nat_rounded_bob': 11100,
  'portrait/natalka_walk_hair_nat_rounded_bob_hat': 11100,
  'portrait/natalka_walk_hair_nat_wavy_lob': 11100,
  'portrait/natalka_walk_hair_nat_wavy_lob_hat': 11100,
  'portrait/natalka_walk_hairback_nat_half_up': 11100,
  'portrait/natalka_walk_hairback_nat_half_up_hat': 11100,
  'portrait/natalka_walk_hairback_nat_long_sleek': 11100,
  'portrait/natalka_walk_hairback_nat_long_sleek_hat': 11100,
  'portrait/natalka_walk_hairback_nat_pigtails': 11100,
  'portrait/natalka_walk_hairback_nat_ponytail': 11100,
  'portrait/natalka_walk_hairback_nat_ponytail_hat': 11100,
  'portrait/natalka_walk_hairback_nat_ringlets': 11100,
  'portrait/natalka_walk_hairback_nat_ringlets_hat': 11100,
  'portrait/natalka_walk_hairback_nat_rounded_bob': 11100,
  'portrait/natalka_walk_hairback_nat_rounded_bob_hat': 11100,
  'portrait/natalka_walk_hairback_nat_wavy_lob': 11100,
  'portrait/natalka_walk_hairback_nat_wavy_lob_hat': 11100,
  'portrait/natalka_walk_nat_bucket_hat': 11100,
  'portrait/natalka_walk_nat_bucket_hat__bare': 11100,
  'portrait/natalka_walk_nat_jacket_denim': 11100,
  'portrait/natalka_walk_neck': 11100,
  'portrait/natalka_walk_spodniczka_black': 11100,
  'portrait/natalka_walk_spodniczka_flowers': 11100,
  'portrait/natalka_walk_spodniczka_jeans': 11100,
};
